var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldDisplay)?_c('span',[(_vm.isModern)?_c('div',[(!_vm.smallCrunch)?_c('h3',{staticClass:"l-spacing"},[_vm._v(" Мир всхлопнулся от переизбытка антиматерии. ")]):_vm._e(),_c('button',{class:{
        'btn-big-crunch': true,
        'btn-big-crunch--small': _vm.smallCrunch
      },on:{"click":_vm.handleClick}},[_vm._v(" Большой Хруст ")])]):_c('div',[_c('button',{class:{
        'o-tab-btn': true,
        'o-big-crunch-btn': true,
        'l-old-ui__big-crunch-btn': true,
        'l-old-ui__big-crunch-btn--overlay': _vm.smallCrunch
      },on:{"click":_vm.handleClick}},[_vm._v(" Большой Хруст ")]),(!_vm.smallCrunch)?_c('div',{staticClass:"o-emptiness"},[_vm._v(" Мир всхлопнулся от переизбытка антиматерии. ")]):_vm._e()])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }